import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function InfoItem({
    heading,
    iconClass,
    subHeading,
    isAvatar,
    avatar,
    hasLink,
}) {
    const icon = isAvatar ? (
        <div className="calander-icon" style={{ minWidth: 50 }}>
            <img src={avatar} alt="" width={35} />
        </div>
    ) : (
        <div className="calander-icon">
            <span className={iconClass}></span>
        </div>
    );
    return (
        <div className="profile">
            <h3 className="titleStyle2">{heading}</h3>
            <div className="tileCard d-flex flex-row align-items-center">
                <div className="col p-0">
                    <div className="d-flex align-items-center">
                        {icon}
                        <div className="userName">
                            {hasLink ? (
                                <a
                                    href={subHeading}
                                    rel="noreferrer"
                                    style={{ wordBreak: 'break-all' }}
                                    target="_blank"
                                >
                                    {subHeading}
                                </a>
                            ) : (
                                subHeading
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

InfoItem.propTypes = {
    // heading to display on top of info item
    heading: PropTypes.string,
    // icon class to render icomoon icon
    iconClass: PropTypes.string,
    // sub-heading to display next to icon
    subHeading: PropTypes.string,
    // boolean that determines if to display icon or avatar
    isAvatar: PropTypes.bool,
    // avatar to render is isAvatar is true
    avatar: PropTypes.string,
    hasLink: PropTypes.bool,
};

InfoItem.defaultProps = {
    heading: '',
    iconClass: 'icon-calendar-empty',
    subHeading: '',
    isAvatar: false,
    avatar: '',
    hasLink: false,
};

export default InfoItem;
